import { c as _c } from "react-compiler-runtime";
import { useCallback, useRef } from 'react';
import { useObserveTableContainerRef } from '../../virtualization/hooks/useObserveTableContainerRef';
import { useResetTableState } from './useResetTableState';
export const useWatchTableContainer = t0 => {
  const $ = _c(12);
  const {
    rowIds,
    scrollContainerRef,
    tableResetKey
  } = t0;
  const {
    handleObserveRef,
    observer
  } = useObserveTableContainerRef();
  const tableContainerRef = useRef(null);
  let t1;
  if ($[0] !== handleObserveRef || $[1] !== scrollContainerRef) {
    t1 = ref => {
      handleObserveRef(ref);
      tableContainerRef.current = ref;
      if (scrollContainerRef) {
        scrollContainerRef.current = ref;
      }
    };
    $[0] = handleObserveRef;
    $[1] = scrollContainerRef;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleTableContainerRef = t1;
  let t2;
  if ($[3] !== handleObserveRef) {
    t2 = () => handleObserveRef(tableContainerRef.current);
    $[3] = handleObserveRef;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const resetObserver = t2;
  let t3;
  if ($[5] !== resetObserver || $[6] !== rowIds || $[7] !== tableResetKey) {
    t3 = {
      rowIds,
      tableContainerRef,
      resetObserver,
      tableResetKey
    };
    $[5] = resetObserver;
    $[6] = rowIds;
    $[7] = tableResetKey;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  useResetTableState(t3);
  let t4;
  if ($[9] !== handleTableContainerRef || $[10] !== observer) {
    t4 = {
      observer,
      handleTableContainerRef
    };
    $[9] = handleTableContainerRef;
    $[10] = observer;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};